import { render, staticRenderFns } from "./Trainitem.vue?vue&type=template&id=8ae60138&scoped=true"
import script from "./Trainitem.vue?vue&type=script&lang=js"
export * from "./Trainitem.vue?vue&type=script&lang=js"
import style0 from "./Trainitem.vue?vue&type=style&index=0&id=8ae60138&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ae60138",
  null
  
)

export default component.exports